<template>
  <div class="profile-photo-circle">
    <div class="profile-photo" style="background-color: white">
      <div
        class="profile-photo relative"
        :style="`background-image: url(${profilePhoto});`"
      ></div>
    </div>
  </div>
</template>

<script>
import { ref } from 'vue';
import { useRoute } from 'vue-router';
import { assetsPath } from '@/mixins/utils';

export default {
  setup () {
    const route = useRoute();

    return { profilePhoto: ref(`${assetsPath(route)}img/nophoto.png`) };
  }
};
</script>

<style>
.profile-photo-circle {
  border-radius: 50%;
  border: 2px solid #00a6c6;
  position: relative;
  width: 100px;
  height: 100px;
}

.profile-photo {
  width: 90%;
  height: 90%;
  border-radius: 50%;
  position: absolute;
  background-size: cover;
  background-position: center center;
  left: 0;
  right: 0;
  bottom: 0;
  top: 0;
  margin: auto;
}

.profile-name {
  text-align: left;
}

.profile-user {
  background-color: white;
  border-bottom: 2px solid #00a6c6;
  height: 180px;
  min-height: 75px;
}
</style>
